import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { GetPaymentManagementSlice } from "../../redux/features/PaymentManagementSlice";
import { Loader } from "../../common/Loader/Loader";
import Pagination from "../../common/pagination/PaginationCustom";
import useParamsFormat from "../../common/Params Values format/ParamsFormat";
import { toast } from "react-toastify";

const PaymentManagement = () => {
  const dispatch = useDispatch();
  const [data, setData] = useState([]);
  const { createDataSetParams } = useParamsFormat();
  const [pagination, setPagination] = useState([]);
  const [handleArrforPage, setHandleArrforPage] = useState(1);
  const [arr, setArr] = useState([]);
  const [page, setPage] = useState(1);
  const [getSearch, setGetSearch] = useState({
    search: "",
    fromDate: "",
    toDate: "",
    page: 1,
  });

  const { loading } = useSelector((state) => state.PaymentManagement);

  useEffect(() => {
    dispatch(GetPaymentManagementSlice()).then((res) => {
      setData(res?.payload?.data?.payment);
      setPagination(res?.payload?.data?.pagination);
    });
  }, []);

  useEffect(() => {
    if (Object.entries(pagination ?? {}).length > 0) {
      setArr(
        [...Array(pagination?.totalPages + 1).keys()]
          .slice(1)
          .slice(handleArrforPage - 1, handleArrforPage + 2)
      );
    }
  }, [pagination, handleArrforPage]);

  const handlePagesIncrease = () => {
    console.log("handleIncrease:", handleArrforPage);
    if (handleArrforPage + 3 <= pagination?.totalPages) {
      setHandleArrforPage((prev) => prev + 3);
    }
  };

  const handlePagesDecrease = () => {
    if (handleArrforPage > 2) {
      setHandleArrforPage((prev) => prev - 3);
    }
  };

  const FetchDataOnPages = (pageNum) => {
    setPage(pageNum);

    setGetSearch((prev) => ({ ...prev, page: pageNum }));

    const dataSet = createDataSetParams({ ...getSearch, page: pageNum });

    dispatch(GetPaymentManagementSlice(dataSet)).then((res) => {
      setData(res?.payload?.data?.payment);
      setPagination(res?.payload?.data?.pagination);
    });
  };

  const HandleSearch = () => {
    //search=hello&fromDate=2024-12-05&toDate=2024-12-19&
    if (
      Object.entries(getSearch)
        .map(([key, value]) => value.length)
        .some((item) => item > 0)
    ) {
      if (
        ![getSearch.fromDate.length, getSearch.toDate.length].every(
          (item) => item === 0
        )
      ) {
        if (
          ![getSearch.fromDate.length, getSearch.toDate.length].every(
            (item) => item > 0
          )
        ) {
          toast.error("Please complete the date!");
          return;
        }
      }

      dispatch(GetPaymentManagementSlice(createDataSetParams(getSearch))).then(
        (res) => {
          setData(res?.payload?.data?.payment);
          setPagination(res?.payload?.data?.pagination);
        }
      );
    }
  };

  const HandleReset = () => {
    if (
      Object.entries(getSearch)
        .map(([key, value]) => value.length)
        .some((item) => item > 0)
    ) {
      setGetSearch({
        search: "",
        fromDate: "",
        toDate: "",
        page: 1,
      });

      dispatch(GetPaymentManagementSlice()).then((res) => {
        setData(res?.payload?.data?.payment);
        setPagination(res?.payload?.data?.pagination);
      });
    }
  };

  return (
    <>
      <>
        <div className="WrapperArea">
          <div className="WrapperBox">
            <div className="TitleBox">
              <h2>Payment management</h2>
              {/* <a class="Button" data-toggle="modal" data-target="#ReturnModal">Return within days</a>                 */}
            </div>
            <div className="tab-content">
              <div className="tab-pane active" id="History">
                <div className="Small-Wrapper">
                  <div className="Filter">
                    <div className="form-group">
                      <label>Search</label>
                      <input
                        type="search"
                        className="form-control"
                        placeholder="Search"
                        name="search"
                        value={getSearch?.search}
                        onChange={(e) =>
                          setGetSearch((prev) => ({
                            ...prev,
                            [e.target.name]: e.target.value,
                          }))
                        }
                      />
                    </div>
                    <div className="form-group">
                      <label>From Date</label>
                      <input
                        type="date"
                        className="form-control"
                        name="fromDate"
                        value={getSearch?.fromDate}
                        onChange={(e) =>
                          setGetSearch((prev) => ({
                            ...prev,
                            [e.target.name]: e.target.value,
                          }))
                        }
                      />
                    </div>
                    <div className="form-group">
                      <label>To Date</label>
                      <input
                        type="date"
                        className="form-control"
                        value={getSearch?.toDate}
                        name="toDate"
                        onChange={(e) =>
                          setGetSearch((prev) => ({
                            ...prev,
                            [e.target.name]: e.target.value,
                          }))
                        }
                      />
                    </div>
                    <div className="form-group">
                      <label>&nbsp;</label>
                      <button
                        className="Button"
                        style={{ marginRight: "10px" }}
                        onClick={HandleSearch}
                      >
                        Apply
                      </button>

                      <button className="Button Cancel" onClick={HandleReset}>
                        <i className="fa fa-refresh" />
                      </button>
                    </div>
                  </div>
                </div>
                <div className="TableList">
                  <table style={{ width: "100%" }}>
                    <thead>
                      <tr>
                        <th>S.No.</th>
                        <th>Transaction Id</th>
                        <th>Transaction Date &amp; Time</th>
                        <th>Total Amount (in Rs.)</th>
                        <th>Booking Id</th>
                        <th>Customer Id</th>
                        <th>Customer Name</th>
                        <th>View Booking Details</th>
                        <th>Payment Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {loading ? (
                        <Loader />
                      ) : Array.isArray(data) && data?.length > 0 ? (
                        data?.map((item, index) => (
                          <tr>
                            <td>
                              {(pagination?.currentPage - 1) * 10 + index + 1}
                            </td>
                            <td>{item?.transactionId}</td>
                            <td>{item?.createdAt?.slice(0, 10)}</td>
                            <td>{item?.totalAmount}</td>
                            <td>{item?.orderId}</td>
                            <td>{item?.customerId}</td>
                            <td>{item?.customerName}</td>
                            <td>
                              <div className="Actions">
                                <Link
                                  className="Blue"
                                  to={"/PaymentDetails"}
                                  state={item}
                                >
                                  <i className="fa fa-eye" />
                                </Link>
                              </div>
                            </td>
                            <td>
                              <span className="Green">
                                {item?.paymentStatus}
                              </span>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={13}>There is no data found</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
                <Pagination
                  arr={arr}
                  page={page}
                  handlePagesIncrease={handlePagesIncrease}
                  FetchDataOnPages={FetchDataOnPages}
                  handlePagesDecrease={handlePagesDecrease}
                />
              </div>
              <div className="tab-pane fade" id="Charges">
                <div className="Small-Wrapper">
                  <div className="TitleBox">
                    <h2>Set Decorator Charges (in TZS)</h2>
                    <div className="Actions">
                      <a className="Green" href="payment-edit.html">
                        <i className="fa fa-pencil" />
                      </a>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-12">
                      <div className="ItineraryArea">
                        <div className="row">
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label>Decorator Charge</label>
                              <input type="text" className="form-control" />
                            </div>
                          </div>
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label>
                                Min. Purchase Amount for free Decorator
                              </label>
                              <input type="text" className="form-control" />
                            </div>
                            <p className="Error">
                              ***** The Decorator charge will be applicable for
                              orders less than min. purchase amount.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <a className="Button Previous" href="#">
                    Save
                  </a>
                </div>
                <br />
                <div className="Small-Wrapper">
                  <div className="TitleBox">
                    <h2>Set Extra Cost (in TZS)</h2>
                    <div className="Actions">
                      <a className="Green" href="payment-edit.html">
                        <i className="fa fa-pencil" />
                      </a>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-12">
                      <div className="ItineraryArea">
                        <div className="row">
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label>Extra Cost for COD</label>
                              <input type="text" className="form-control" />
                            </div>
                            <p className="Error">
                              ******The extra cost will not apply to orders that
                              have completed online payments.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <a className="Button Previous" href="#">
                    Save
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="ModalBox">
          <div id="ReturnModal" className="modal fade" role="dialog">
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-body">
                  <div className="Category">
                    <a
                      href="javascript:void(0);"
                      className="CloseModal"
                      data-dismiss="modal"
                    >
                      ×
                    </a>
                    {/* <h3>Select Days</h3>  */}
                    <div className="form-group">
                      <label>Select Days</label>
                      <select className="form-control">
                        <option value="Active Users">--Select--</option>
                        <option value="Active Users">10 Days</option>
                        <option value="Active Users">15 Days</option>
                      </select>
                    </div>
                    <a href="#" className="Button">
                      Save
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    </>
  );
};

export default PaymentManagement;
